import React, { useState, Fragment } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { some, values } from 'lodash-es';

import CopyToClipboard from './CopyToClipboard';
import MultiEmailInput from './MultiEmailInput';
import axios from '../../configs/axios';

const defaultRequestStatus = { loading: false, error: false, submitted: false };
// This component needs refactoring
const ShareLinkForm = ({
  requestUrl,
  shareLinkUrl,
  maxEmailsCount = 5,
  successMessage = 'Link has been shared!',
  buttonText = 'Share',
  className,
  onClose,
  onSubmitSuccess,
  isMobileMode,
}) => {
  const [showCopied, setShowCopied] = useState(false);
  const [inputFocus, setInputFocus] = useState(true);
  const [emails, setEmails] = useState([]);
  const [reguestStatus, setRequestStatus] = useState(defaultRequestStatus);

  const hasInvalid = some(emails, ['isValid', false]);
  const isSubmitDisabled = hasInvalid || !emails.length || reguestStatus.loading;

  const handleClose = () => {
    if (!reguestStatus.loading) onClose();
  };

  const handleFocus = () => {
    setInputFocus(false);
  };
  const handleBlur = (hasValidEmail) => {
    if (hasValidEmail) {
      setInputFocus(true);
    }
  };

  const handleShareSubmit = () => {
    if (isSubmitDisabled) return;

    setRequestStatus({ loading: true, error: false, submitted: false });
    axios.post(requestUrl, { emails: emails.map(e => e.value) })
      .then(() => {
        if (onSubmitSuccess) onSubmitSuccess();
        setRequestStatus({ loading: false, error: false, submitted: true });
      })
      .catch(() => {
        setRequestStatus({ loading: false, error: true, submitted: false });
      });
  };

  return (
    <Fragment>
      {isMobileMode ? (
        <div className={cx('share-link-form share-link-form-mobile', className)}>
          <div className="share-link-form-header">
            <span onClick={handleClose} className="hicon-angle-right-alt" />
            <h2 className="share-link-form-header-title text-capitilize">Share Report</h2>
          </div>
          <div className="share-link-form-body">
            <MultiEmailInput
              onChange={setEmails}
              maxEmailsCount={maxEmailsCount}
              disabled={values(reguestStatus).includes(true)}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </div>
          <div className="share-link-form-footer">
            {!reguestStatus.submitted && !reguestStatus.error && (
              <button
                type="button"
                className="btn share-link-form-btn"
                onClick={handleShareSubmit}
                disabled={inputFocus && (isSubmitDisabled)}
              >
                {buttonText}
              </button>
            )}

            {reguestStatus.submitted && <p className="share-link-form-submitted"><span className="text-blue hicon-check-bold" /> {successMessage}</p>}
            {reguestStatus.error && <p className="share-link-form-error">Something went wrong, please try again</p>}
          </div>
          {showCopied && <p className="share-link-form-copied text-center"><span className="text-blue hicon-check-bold" /> Link copied!</p>}
          {shareLinkUrl && (
            <CopyToClipboard
              copyButtonText="Copy Report Link"
              copyIcon="hicon-copy-link-3"
              copyValue={shareLinkUrl}
              tooltipContent="Copy link"
              onCopyStateChange={setShowCopied}
            />
          )}
        </div>
        ) : (
          <div className={cx('share-link-form', className)}>
            <div className="share-link-form-header">
              <span onClick={handleClose} className="hicon-angle-right-alt" />
              <h2 className="share-link-form-header-title">Share</h2>
              <span onClick={handleClose} className="hicon-close-2" />
            </div>
            <div className="share-link-form-body">
              {shareLinkUrl && (
                <CopyToClipboard
                  copyValue={shareLinkUrl}
                  tooltipContent="Copy link"
                  showCopyValue
                  onCopyStateChange={setShowCopied}
                />
              )}

              <MultiEmailInput
                onChange={setEmails}
                maxEmailsCount={maxEmailsCount}
                disabled={values(reguestStatus).includes(true)}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />

              {showCopied && <p className="share-link-form-copied"><span className="text-blue hicon-check-bold" /> Link copied to clipboard</p>}
            </div>
            <div className="share-link-form-footer">
              {!reguestStatus.submitted && !reguestStatus.error && (
                <button
                  type="button"
                  className="btn share-link-form-btn"
                  onClick={handleShareSubmit}
                  disabled={requestUrl && inputFocus && (isSubmitDisabled)}
                >
                  <span className="hicon-share-outline" />
                  {buttonText}
                </button>
              )}

              {reguestStatus.submitted && <p className="share-link-form-submitted"><span className="text-blue hicon-check-bold" /> {successMessage}</p>}
              {reguestStatus.error && <p className="share-link-form-error">Something went wrong, please try again</p>}
            </div>
          </div>
        )}
    </Fragment>
  );
};

ShareLinkForm.propTypes = {
  requestUrl: T.string,
  shareLinkUrl: T.string,
  maxEmailsCount: T.number,
  successMessage: T.string,
  buttonText: T.string,
  className: T.string,
  onClose: T.func.isRequired,
  onSubmitSuccess: T.func,
  isMobileMode: T.bool,
};

export default ShareLinkForm;
